<app-edit-article-in-offer-form></app-edit-article-in-offer-form>
